import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GetOrderStoreServiceModule } from '@common/services/my-booking/get-order-store/get-order-store.module';
import { ButtonModule } from '@lib/components';
import { StaticMsgModule } from '@lib/pipes';
import { DialogDisplayServiceModule, ModalServiceModule } from '@lib/services';
import { AswContextStoreModule, AswMasterStoreModule } from '@lib/store';
import { MenuComponent } from './menu.component';

@NgModule({
  declarations: [MenuComponent],
  imports: [
    CommonModule,
    AswContextStoreModule,
    AswMasterStoreModule,
    DialogDisplayServiceModule,
    ModalServiceModule,
    ButtonModule,
    StaticMsgModule,
    GetOrderStoreServiceModule,
  ],
  exports: [MenuComponent],
})
export class MyBookingMenuModule {}
